import Box from '@mui/material/Box';
import { businessData as businessDataAtom } from 'atoms';
import ServiceHome from 'pages/Business/Service/ServiceHome';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';

import * as React from 'react';

import AvailabilityHome from '../Availability/AvailabilityHome';
import BusinessHome from '../Business/BusinessHome';
import OfficeStaffHome from '../OfficeStaff/OfficeStaffHome';
import OutOfOfficeHome from '../OutOfOffice/OutOfOfficeHome';
import ProviderHome from '../Provider/ProviderHome';

const ContainerDiv = styled.div`
    display: flex;
    flex-direction: column;

    .MuiBox-root {
        background: white !important;
        padding: 0;
    }

    .MuiButtonBase-root {
        color: ${(props) => props.theme.colorPrimary};
        text-align: center;
        font-family: Poppins, serif;
        font-size: 16px;
        font-weight: 700;
    }
`;

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            style={{ flexGrow: 1, display: value === index ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}
            {...other}
        >
            {value === index && <Box sx={{ 
                pt: 1, 
                pb: 2, 
                px: 7.5, 
                flex: 1, 
                backgroundColor: '#f5f1ed', 
                height: '100%', 
                minHeight: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                '@media (max-width: 960px)': {
                    paddingLeft: '32px',
                    paddingRight: '32px',
                },
                '@media (max-width: 640px)': {
                    paddingLeft: '20px',
                    paddingRight: '20px',
                },
            }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

export default function TabsStructure({ value, setValue }) {
    const [business] = useRecoilState(businessDataAtom);
    
    // Check if business exists and set tabs accordingly
    const isBuisnessAdded = business?.email?.length > 0 && business?.id > 0;

    // Reset to Business tab if no business exists
    React.useEffect(() => {
        if (!isBuisnessAdded && value !== 0) {
            setValue(0);
        }
    }, [isBuisnessAdded, value, setValue]);

    // Define tabs based on business existence
    const tabs = [
        {
            label: "Business",
            component: <BusinessHome />
        }
    ];

    // Add other tabs only if business exists
    if (isBuisnessAdded) {
        tabs.push(
            {
                label: "Services",
                component: <ServiceHome />
            },
            {
                label: "Availability",
                component: <AvailabilityHome />
            },
            {
                label: "Providers",
                component: <ProviderHome />
            },
            {
                label: "Office Staff",
                component: <OfficeStaffHome />
            },
            {
                label: "Out of Office",
                component: <OutOfOfficeHome />
            }
        );
    }

    return (
        <ContainerDiv style={{ height: '100%' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#f5f1ed', height: '100%', flex: 1 }} className={'bg-white'}>
                {isBuisnessAdded ? (
                    <>
                        {tabs.map((tab, index) => (
                            <CustomTabPanel key={index} value={value} index={index}>
                                {tab.component}
                            </CustomTabPanel>
                        ))}
                    </>
                ) : (
                    // Show BusinessHome component directly without tabs for first-use experience
                    <Box sx={{ 
                        pt: 2, 
                        pb: 2, 
                        px: 7.5, 
                        flex: 1, 
                        backgroundColor: '#f5f1ed', 
                        height: '100%', 
                        minHeight: '100%', 
                        display: 'flex', 
                        flexDirection: 'column',
                        '@media (max-width: 960px)': {
                            paddingLeft: '32px',
                            paddingRight: '32px',
                        },
                        '@media (max-width: 640px)': {
                            paddingLeft: '20px',
                            paddingRight: '20px',
                        },
                    }}>
                        <BusinessHome />
                    </Box>
                )}
            </Box>
        </ContainerDiv>
    );
}
